import Helper from "./Helper";

class Glossary {
  constructor(config = {}) {
    const {
      glossaryItemsSelector
    } = config;

    this.glossaryItems = Array.prototype.slice.call(document.querySelectorAll(glossaryItemsSelector));

    if(this.glossaryItems){
      this.addGlossary();
      this.addEvents();
    }
  }

  addGlossary(){
    let content = document.querySelector(".content__inner");
    let glossaryWrapper = document.createElement("div");
    glossaryWrapper.classList.add("glossary__items");
    if(glossary_json){
      for (let key in glossary_json['glossary']){
        let glossaryItem = document.createElement("div");
        let glossaryItemTitel = document.createElement("p");
        let glossaryItemDescription = document.createElement("p");
        let glossaryClose = document.createElement("span");
        glossaryItem.classList.add("glossary__item");
        glossaryItem.classList.add("glossary__item--" + key.toLowerCase().replace(/[\W_]+/g,""));
        glossaryItemTitel.classList.add("glossary__title");
        glossaryItemDescription.classList.add("glossary__description");
        glossaryClose.classList.add("ns-icon");
        glossaryClose.classList.add("glossary__close");
        glossaryClose.addEventListener("click", e => {
          this.closeGlossary();
        });
        glossaryItemTitel.innerText = glossary_json['glossary'][key]['title'];
        glossaryItemDescription.innerHTML = glossary_json['glossary'][key]['description'];
        glossaryItem.insertAdjacentElement("beforeend", glossaryItemTitel);
        glossaryItem.insertAdjacentElement("beforeend", glossaryItemDescription);
        glossaryItem.insertAdjacentElement("beforeend", glossaryClose);
        glossaryWrapper.insertAdjacentElement("beforeend", glossaryItem);
      }
    }
    content.insertAdjacentElement("beforeend", glossaryWrapper);
  }

  addEvents(){
    document.addEventListener("click", e => {
      this.closeGlossary();
    });

    this.glossaryItems.forEach(item => {
      item.addEventListener("click", e => {

        setTimeout(e => {
          this.closeGlossary();
          let itemSelector = item.innerText.toLowerCase().replace(/[\W_]+/g,"");
          let itemBox = item.getBoundingClientRect();
          let contentBox = document.querySelector(".content__inner").getBoundingClientRect();
          let left = itemBox.left - contentBox.left;
          let top = itemBox.top - contentBox.top;

          if(document.querySelector(".glossary__item--" + itemSelector)){

            document.querySelector(".glossary__item--" + itemSelector).classList.add("glossary__item--active");
            document.querySelector(".glossary__item--" + itemSelector).style.opacity = 0;

            let contentInnerHeight = document.body.clientHeight
            - document.querySelector('.header').clientHeight
            - document.querySelector('.reading-progress__container').clientHeight;

            if(top + document.querySelector(".glossary__item--" + itemSelector).getBoundingClientRect().height > contentInnerHeight) {
              top = contentInnerHeight - document.querySelector(".glossary__item--" + itemSelector).getBoundingClientRect().height;
            }

            document.querySelector(".glossary__item--" + itemSelector).style.top = top - 20 + "px";
            document.querySelector(".glossary__item--" + itemSelector).style.left = left - 20 + this.checkOverflow(item) + "px";
            document.querySelector(".glossary__item--" + itemSelector).style.opacity = 1;

          }
        }, 10);
      });
    });
  }

  checkOverflow(el){
    let contentInner = document.querySelector(".content__inner");
    let activeBox = el;
    let contentInnerRect = contentInner.getBoundingClientRect();
    let activeBoxRect = activeBox.getBoundingClientRect();

    if(300 + activeBoxRect.left > contentInnerRect.width){
      return contentInnerRect.width - (300 + activeBoxRect.left);
    } else {
      return 0;
    }
  }


  closeGlossary(){
    if(document.querySelector(".glossary__item--active")){
      document.querySelector(".glossary__item--active").classList.remove("glossary__item--active");
    }
  }
}
export default Glossary;
